module.exports = __webpack_public_path__ + "img/apple-fitness.ac9c3f6c.png";